import jwtDecode from 'jwt-decode';

function toDate(unixEpoch) {
    return new Date(unixEpoch * 1000);
}

class UserToken {
    constructor(token) {
        try {
            const { jti, sub, iss, exp, iat, name, preferred_username } = jwtDecode(token);

            this._token = token;
            this._jti = jti;
            this._sub = sub;
            this._iss = iss;
            this._exp = exp;
            this._iat = iat;
            this._name = name;
            this._username = preferred_username;
        } catch (e) {
            this._token = null;
            this._jti = null;
            this._sub = null;
            this._iss = null;
            this._exp = null;
            this._iat = null;
        }
    }

    getRawToken() {
        return this._token;
    }

    getIdentifier() {
        return this._jti;
    }

    getUserUUID() {
        return this._sub;
    }

    getIssuer() {
        return this._iss;
    }

    getExpirationDate() {
        return this._exp !== null ? toDate(this._exp) : null;
    }

    getIssuingDate() {
        return this._iat !== null ? toDate(this._iat) : null;
    }

    getName() {
        return this._name;
    }

    getUsername() {
        return this._username;
    }

    isValid() {
        const expirationTime = this.getExpirationDate();
        if (expirationTime === null) {
            return false;
        }
        return +expirationTime > Date.now();
    }
}

export default {
    create(token) {
        return new UserToken(token);
    }
};
